// src/pages/monthlyFlux/hooks/useMonthlyFluxData.js
// V4 - Version corrigée

import { useCallback, useEffect, useRef, useState } from 'react';
import { getMonthlyFlux } from '../../../../services/rapportService';

const DEFAULT_FILTERS = {
    date_debut: null,
    date_fin: null,
    marque_id: null,
    taille_id: null,
    couleur_id: null,
    categorie_id: null,
    id_produit: null,
    groupBy: 'mois'
};

export default function useMonthlyFluxData() {
    const filtersRef = useRef(DEFAULT_FILTERS);
    const [filters, setFilters] = useState(DEFAULT_FILTERS);
    
    // Stocker toute la réponse
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    
    // Données extraites
    const [months, setMonths] = useState([]);
    const [totaux, setTotaux] = useState(null);
    const [coherence, setCoherence] = useState(null);
    const [indicateurs, setIndicateurs] = useState(null);
    const [periode, setPeriode] = useState({});
    const [filtresAppliques, setFiltresAppliques] = useState({});

    const fetchData = useCallback(async (patch = {}) => {
        const next = { ...filtersRef.current, ...patch };
        filtersRef.current = next;
        setFilters(next);
        setLoading(true);
        setError(null);
        
        try {
            const response = await getMonthlyFlux(next);
            
            // ✅ CORRECTION: response.data.data contient les données
            // Structure: { success: true, data: { months, totaux, ... }, meta: {...} }
            const apiData = response.data?.data || response.data;
            
            console.log('📊 API Response:', response);
            console.log('📊 API Data:', apiData);
            
            // ✅ Extraire les données
            setResponse(apiData);
            setMonths(apiData?.months || []);
            setTotaux(apiData?.totaux || null);
            setCoherence(apiData?.coherence || null);
            setIndicateurs(apiData?.indicateurs || null);
            setPeriode(apiData?.periode || {});
            setFiltresAppliques(apiData?.filtres_appliques || {});
            
            return apiData;
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.message;
            setError(errorMessage);
            console.error('❌ useMonthlyFluxData error:', errorMessage);
            throw err;
        } finally {
            setLoading(false);
        }
    }, []);

    const refreshWithFilters = useCallback((patch = {}) => {
        return fetchData(patch);
    }, [fetchData]);

    const resetFilters = useCallback(() => {
        return fetchData(DEFAULT_FILTERS);
    }, [fetchData]);

    // Chargement initial
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return {
        data: response,
        months,
        periode,
        filtresAppliques,
        loading,
        error,
        filters,
        totaux,
        coherence,
        indicateurs,
        fetchData,
        refreshWithFilters,
        resetFilters,
        setFilters: refreshWithFilters
    };
}